import { AnyAction } from "redux";

import { APIResponse } from "../types/APIResponseType";

export const handleApiResponse = (
  response: APIResponse,
  successDispatcher: (data: any) => AnyAction,
  errorDispatcher: (error: string) => AnyAction,
): AnyAction => {
  if (response.success) {
    errorDispatcher("");
    return successDispatcher(response.payload);
  }
  errorDispatcher(response.error || "There was an error with this request.");
  throw new Error(response.error);
};
